import * as ACTIONS from "./types"

export const log_action = text => ({
  type: ACTIONS.LOG_ACTION,
  payload: text
})
